import React from "react"
import Image from "./image"
import { Link } from "gatsby"


const Thumbnail = ({ to, src, alt, detail}) => {

  return (
    <React.Fragment>
        <Link to={to} className="card flex center" title={alt}>
          <Image styled={true} src={src} alt={alt}/>              
        </Link>
    </React.Fragment>
  );
}


Thumbnail.defaultProps = {
  to:``,
  src:``,
  alt:``,
  meta:``
}


export default Thumbnail




 